import { customVisualSchema } from "@redotech/redo-model/conversion/custom-checkout-split-metrics/custom-visual";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const getCustomVisualsDataForSplit = {
  name: "getCustomVisualsDataForSplit" as const,
  input: z.object({ splitId: zExt.objectId() }),
  output: z.object({
    visualsData: z.array(
      z.object({
        customVisual: customVisualSchema,
        data: z.object({
          rows: z.array(z.array(z.union([z.string(), z.number()]))),
        }),
      }),
    ),
    // dimension definition id -> value -> label
    categoricalDimensionValueLabels: z.record(
      z.string(),
      z.record(z.string(), z.string()),
    ),
  }),
};
export type GetCustomVisualsDataForSplitOutput = z.infer<
  typeof getCustomVisualsDataForSplit.output
>;
